// extracted by mini-css-extract-plugin
export default {"homeContent__top":"c-i_cr","homeContent__bottom":"c-i_cs","homeContent__cardHolder":"c-i_ct","homeContent__seoTextHolder":"c-i_cu"};